import classNames from 'classnames'
import dayjs from 'dayjs'
import { Button, Card } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import MaterialIcon from '../../../components/MaterialIcon'
import { usePropostaCliente } from '../../../hooks/proposte'
import { AreaClientiRedirect } from '../../AreaClientiRedirect'
import CardDettaglio from '../CardDettaglio'
import { CardElencoBilance } from '../CardElencoBilance'

export default function PropostaDettaglioCliente() {
  const { id } = useParams()
  const { data: proposta, refetch, isError } = usePropostaCliente(String(id))
  const router = useNavigate()

  const propostaCompilabile = ['inviata', 'sollecitata', 'scaduta'].includes(proposta?.stato ?? '')

  if (isError) {
    return <AreaClientiRedirect message="Pagina non disponibile" />
  }

  return (
    <div className="page mb-5">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                router(-1)
              }}
              className="p-sm no-link d-flex align-items-center pointer"
            >
              <span className="material-icons text-secondary">group</span>
              <span className="ms-2">Lista proposte</span>
            </div>
            <span className="material-icons text-secondary">chevron_right</span>
            <span className="ms-2 p-sm  bg-secondary-light p-2 text-secondary rounded">Dettaglio proposta</span>
          </div>
        </div>
        <div className="col-12 d-flex align-items-center mt-2">
          <h1 className="title">{proposta?.cliente_ragione_sociale}</h1>
          <div className="flex-grow-1"></div>
          {propostaCompilabile && (
            <Button
              onClick={() => {
                const wx = window.open(
                  `/form-proposta/${id}`,
                  'Compila proposta',
                  'height=500,width=800,resizable=yes,scrollbars=yes'
                )
                wx?.addEventListener('unload', () => {
                  refetch()
                })
              }}
              variant="secondary"
              className="text-white d-flex align-items-center"
              type="button"
            >
              Compila
            </Button>
          )}
          {proposta?.stato === 'prenotata' && (
            <Button
              variant="secondary"
              className="text-white d-flex align-items-center"
              onClick={async () => {
                window.open(proposta.certificato_prenotazione ?? '', '_blank')
              }}
            >
              <MaterialIcon icon="download" className="me-2" />
              <span>Scarica certificato</span>
            </Button>
          )}
        </div>
        <div className="col-12 d-flex align-items-center mt-2">
          <div
            className={classNames('badge text-capitalize', {
              'badge-state-success': proposta?.stato === 'accettata' || proposta?.stato === 'prenotata',
              'badge-state-all': proposta?.stato === 'scaduta',
              'badge-state-warning': proposta?.stato === 'inviata' || proposta?.stato === 'sollecitata',
              'badge-state-danger': proposta?.stato === 'rifiutata' || proposta?.stato === 'annullata',
            })}
          >
            {proposta?.stato}
          </div>
          <div className="ms-3">
            <span>Inviata in data: </span>
            {dayjs(proposta?.data_creazione).format('DD/MM/YYYY')}
          </div>
        </div>
        <div className="col-12">
          <div className="row mt-3">
            <div className="col-md-5">
              <CardDettaglio proposta={proposta} />
            </div>
            <div className="col-md-7">
              <Card>
                <CardElencoBilance proposta={proposta} />
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
